// src/store/api/providerApi.js
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const offerApi = createApi({
  reducerPath: "offerApi",
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env.VITE_API + "services/offer",
    prepareHeaders: (headers, { getState }) => {
      const token = getState()?.userSlice?.token; // ✅ بدون store
      if (token) headers.set("Authorization", `Bearer ${token}`);
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getServiceOffer: builder.query({
      // ✅ supports both JSON update + multipart (nationalCardImg/certificates)
      query: ({ serviceId }) => {
        return {
          url: `/service-offer/${serviceId}`,
          method: "GET",
        };
      },
    }),

    // getOneServiceOffer: builder.mutation({
    //     // ✅ supports both JSON update + multipart (nationalCardImg/certificates)
    //     query: ({ offerId }) => {
    //       return {
    //         url: `/service-offer/${offerId}`,
    //         method: "GET",
    //       };
    //     },
    // }),

     getOneServiceOffer: builder.query({
        // ✅ supports both JSON update + multipart (nationalCardImg/certificates)
        query: ({ offerId }) => {
          return {
            url: `/${offerId}`,
            method: "GET",
          };
        },
    }),
     deleteServiceOffer: builder.mutation({
        // ✅ supports both JSON update + multipart (nationalCardImg/certificates)
        query: ({ offerId }) => {
          return {
            url: `/${offerId}`,
            method: "DELETE",
          };
        },
    }),
    createServiceOffer: builder.mutation({
      query: ({
        note,
        duration,
        proposedPrice,
        provider,
        serviceRequestId,
      } = {}) => {
        const payload = {};

        if (note != null) payload.note = note;
        if (duration != null) payload.duration = duration;
        if (proposedPrice != null) payload.proposedPrice = proposedPrice;
        if (provider != null) payload.provider = provider;
        if (serviceRequestId != null)
          payload.serviceRequestId = serviceRequestId;

        return {
          url: `/`,
          method: "POST",
          body: payload,
        };
      },
    }),

     updateOfferStatus: builder.mutation({
      query: ({
        status,
        offerId
      } = {}) => {
        const payload = {status};

        return {
          url: `/${offerId}`,
          method: "PATCH",
          body: payload,
        };
      },
    }),
  }),
});

export const { useGetServiceOfferQuery, useCreateServiceOfferMutation, useGetOneServiceOfferQuery ,useDeleteServiceOfferMutation, useUpdateOfferStatusMutation} =
  offerApi;
